<template>
    <div class="fhv-centent">
        <h4 class="title-topic">Guest WIFI</h4>
        <el-alert title="Some parameters in subRouter mode are forbidden to be modified!" type="warning" show-icon
        :closable="false" v-if="$G_DEVICE_CFG.isSubRouter"></el-alert>
        <el-alert title="2.4G WiFi has been turned off. To use guest WiFi, you need to turn on 2.4G WiFi first!" type="warning" show-icon
        :closable="false" v-if="!wl1Enable"></el-alert>
        <el-form 
        :model="wlform"  
        label-width="180px" 
        label-position="left"
        class="fhv-form" 
        size="mini"
        :rules="formCheck" 
        ref="wlform"
        :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"
        v-loading="getLoad"
        >
            <el-form-item label="Enable Guset">
                <el-switch v-model="wlform.wl1.enable" @change="setWlEnabelData()" 
                :disabled="!wl1Enable"></el-switch>
            </el-form-item>
            <div v-show="wlform.wl1.enable">
            <el-form-item label="SSID :" prop="wl1.SSID">
                <el-input v-model.trim="wlform.wl1.SSID"></el-input>
            </el-form-item>
            <el-form-item label="Authentication :" >
                <el-select v-model="wlform.wl1.authMode" style="width: 100%" placeholder="Please select authentication mode">
                    <el-option label="OPEN" :value="0"></el-option>
                    <el-option label="WPA PSK" :value="2"></el-option>
                    <el-option label="WPA2 PSK" :value="4"></el-option>
                    <el-option label="WPA PSK/WPA2 PSK MIXED" :value="6"></el-option>
                </el-select>
            </el-form-item>

            <div v-if="parseInt(wlform.wl1.authMode) > 1">
                <el-form-item label="WPA Preshare key :" prop="wl1.password">
                    <el-input :type="is1ShowKey ? 'text' : 'password'" v-model.trim="wlform.wl1.password">
                        <i slot="suffix" class="el-input__icon glyphicon  fhv-password" 
                        :class="[is1ShowKey ? 'glyphicon-eye-close' : 'glyphicon-eye-open']"
                        @click="is1ShowKey = !is1ShowKey"></i>
                    </el-input>
                </el-form-item>
            </div>

            <el-form-item label="Duration :" >
                <el-select v-model="wlform.wl1.day" @change="selectDayMode" style="width: 40%">
                    <el-option
                        v-for="item in dayListG"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <label class="fhv-label" v-if="!isNoTimeLimited">Day</label>
                <el-select v-model="wlform.wl1.hour" style="width: 40%" v-if="!isNoTimeLimited">
                    <el-option
                        v-for="item in hourListG"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <label class="fhv-label" v-if="!isNoTimeLimited">Hour</label>
            </el-form-item>
            <el-form-item label="Time remaining :" v-if="!isNoTimeLimited">
                <span>{{wlform.timeRemain.day}}</span><label class="fhv-label">Day</label>
                <span>{{wlform.timeRemain.hour}}</span><label class="fhv-label">Hour</label>
                <span>{{wlform.timeRemain.minute}}</span><label class="fhv-label">Minute</label>
                <span>{{wlform.timeRemain.second}}</span><label class="fhv-label">Second</label>
            </el-form-item>
            </div>
            <el-form-item>
                <el-button :disabled="!wl1Enable" type="primary" @click="apply">Apply</el-button>
                <el-button :disabled="!wl1Enable" type="primary" @click="refresh">Refresh</el-button>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>
import validator from 'validator'
import devConfig from '@/devConfig'
import sizeof from '@/util/jsCharLength.js'

var timer;

export default {
    data(){
       return {
           dayListG: [
           ],
           hourListG: [
           ],
           wl1Enable: true,
           isNoTimeLimited:false,
           is1ShowKey:false,
           getLoad:false,
           wlform:{
               wl1:{ //2.4G
                   enable:true,
                   SSID:'',
                   password:'',
                   authMode:4,
                   day: 1,
                   hour: 0,
                   duration: 0
               },
               timeRemain: {
                   day: 0,
                   hour: 0,
                   minute: 0,
                   second: 0
               }
           },
           formCheck:{
               wl1:{
                   SSID:[
                        { required: true, message: 'Please enter SSID name', trigger: 'blur' },
                        { 
                            validator:(rule, value, callback) => {
                                if(sizeof(value,'utf-8') > 30 || sizeof(value,'utf-8') < 1)
                                    callback(new Error("SSID name cannot be longer than 30 byte"))
                                else
                                    callback()
                            },
                            trigger: 'blur' 
                        }
                    ],
                   password:[
                        { required: true, message: 'Please enter WPA Preshare key', trigger: 'blur' },
                        { 
                            validator:(rule, value, callback) => {
                                if(sizeof(value,'utf-8') > 64 || sizeof(value,'utf-8') < 8)
                                    callback(new Error("WPA Preshare key must 8~64 byte"))
                                else
                                    callback()
                            },
                            trigger: 'blur' 
                        }
                    ],
               }
                
           } 
       }
    },
    created(){
        devConfig.init(this,()=>{
            this.initTimeOption();
            this.getData()
        })
        
    },
    computed:{
        
    },
    methods:{
        getData(){
            this.getLoad = true
            axios
            .post("/JSONAPI",{
                cmdType:"GET_WLAN_GUEST",

            })
            .then((response)=>{
                this.getLoad = false
                if(response.data.ret == '0')
                {
                    this.wl1Enable = response.data.allEnable;
                    if (this.wl1Enable) {
                        this.wlform.wl1.enable = response.data.wl1.enable;
                    }else {
                        this.wlform.wl1.enable = this.wl1Enable;
                    }
                    this.wlform.wl1.SSID = response.data.wl1.SSID
                    this.wlform.wl1.password = response.data.wl1.password
                    this.wlform.wl1.authMode = response.data.wl1.authMode
                    this.wlform.wl1.day = response.data.wl1.duration == "" ? 1 : parseInt(response.data.wl1.duration);
                    this.wlform.wl1.hour = response.data.wl1.durationHour == "" ? 0 : parseInt(response.data.wl1.durationHour);
                    this.wlform.wl1.duration = response.data.wl1.guestendtime - response.data.time;
                    if (this.wlform.wl1.enable) {
                        if(response.data.wl1.duration == 9999){
                            this.isNoTimeLimited = true;
                        }else{
                            this.isNoTimeLimited = false;
                            clearInterval(timer);
                            timer = setInterval(() => { 
                                this.showDuration()
                            }, 1000);
                        }                        
                    }
                }
            })
        },
        setData(){
            const loadingInstance = this.$loading({lock: true})
            if(this.wlform.wl1.day == 9999){
                this.wlform.wl1.hour = 0;
                this.wlform.timeRemain.day = 0;
                this.wlform.timeRemain.hour = 0;
                this.wlform.timeRemain.minute = 0;
                this.wlform.timeRemain.second = 0;
                clearInterval(timer);
            }
            let postData = {
                cmdType:"SET_WLAN_GUEST",
                wl1:{
                    enable:this.wlform.wl1.enable ? '1' : '0',
                    SSID:this.wlform.wl1.SSID,
                    password:this.wlform.wl1.password,
                    authMode:this.wlform.wl1.authMode,
                    day:this.wlform.wl1.day.toString(),
                    hour:this.wlform.wl1.hour.toString()
                }
            }


            axios
            .post("/JSONAPI",postData)
            .then((response)=>{
                setTimeout(()=>{
                    loadingInstance.close()
                    if(response.data.ret == '0'){
                        this.$message.success("Configuration is successful!")
                        this.getData()
                    }
                    else
                        this.$message.error("Configuration failed!")
                },6000)
            })
        },
        apply(){
            this.$refs['wlform'].validate((valid) => {
                if (valid) {
                    this.setData()
                } else {
                    return false
                }
            })
        },
        refresh(){
            this.isShowKey = false
            this.$refs['wlform'].resetFields()
            this.getData()
        },
        setWlEnabelData(){
            
        },
        initTimeOption() {
            for (var i = 0; i < 24; i++) {
                var optionObject = {};
                optionObject.value = optionObject.label = i;
                if (i < 8) {
                    this.dayListG.push(optionObject);
                }
                this.hourListG.push(optionObject);
            } 
            this.dayListG.push({"value":9999,"label":"No limited"});
        },
        showDuration() {
            if (this.wlform.wl1.duration != "" && this.wlform.wl1.duration > 0) {
                this.wlform.wl1.duration--;
                this.wlform.timeRemain.day = parseInt(this.wlform.wl1.duration / 86400);
                this.wlform.timeRemain.hour = parseInt(this.wlform.wl1.duration % 86400 / 3600);
                this.wlform.timeRemain.minute = parseInt(this.wlform.wl1.duration % 86400 % 3600 / 60);
                this.wlform.timeRemain.second = parseInt(this.wlform.wl1.duration % 86400 % 3600 % 60);
            }else {
                clearInterval(timer);
                this.wlform.wl1.enable = false;
            }
        },
        selectDayMode(){
            if(this.wlform.wl1.day == 9999){
                this.isNoTimeLimited = true;
            }else{
                this.isNoTimeLimited = false;
            }
        }
    },
}
</script>

<style>
.fhv-password{
    cursor:pointer
}
.fhv-label {
    margin: 0px 5px 0px 5px;
}
</style>
